import isObject from 'lodash/isObject';

import { PROFILE_FIELDS_TYPES } from '../../../constants/formFields';

export const adaptInitialValueState = (stateName, listStates) => {
  if (isObject(stateName)) return stateName;
  const targetState = listStates.find(({ label }) => label === stateName);
  const safeStateValue = stateName
    ? {
        label: stateName,
        value: stateName,
      }
    : null;
  return stateName && listStates && targetState
    ? {
        label: targetState.label,
        value: targetState.value,
      }
    : safeStateValue;
};

export const adaptInitialValueCountry = (countryName, listCountry) => {
  if (isObject(countryName)) return countryName;
  const targetCountry = listCountry.find(({ label }) => label === countryName);
  return countryName && listCountry && targetCountry
    ? {
        label: targetCountry.label,
        value: targetCountry.value,
      }
    : null;
};

export const adaptInitialValue = (stateValue, list) => {
  if (isObject(stateValue)) return stateValue;
  const target = list.find(({ value }) => value === stateValue);

  return stateValue && list && target
    ? {
        label: target.label,
        value: target.value,
      }
    : null;
};

export const makeInitialValue = (
  data,
  countryList,
  stateList,
  isEirVisitType,
  onlyCountryState = false,
) => {
  return onlyCountryState
    ? {
        [PROFILE_FIELDS_TYPES.COUNTRY]: adaptInitialValueCountry(
          data.country,
          countryList,
        ),
        [PROFILE_FIELDS_TYPES.STATE]: adaptInitialValueState(
          data.state,
          stateList,
        ),
      }
    : {
        [PROFILE_FIELDS_TYPES.HOME_PHONE]: data.homePhone,
        [PROFILE_FIELDS_TYPES.ADDRESS_1]: data.address1,
        [PROFILE_FIELDS_TYPES.ADDRESS_2]: data.address2,
        [PROFILE_FIELDS_TYPES.COUNTRY]: adaptInitialValueCountry(
          data.country,
          countryList,
        ),
        [PROFILE_FIELDS_TYPES.CITY]: data.city,
        [PROFILE_FIELDS_TYPES.STATE]: adaptInitialValueState(
          data.state,
          stateList,
        ),
        [PROFILE_FIELDS_TYPES.POSTAL_CODE]: data.postalCode,
      };
};



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/HomeAddress/utils.js